import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { combineReducers } from "redux";

const contactInfoSummaryReducer = (state = initialState.summary.contactInfoSummary, action) => {
  switch (action.type) {
    case types.LOAD_PARTNER_CONTACT_INFO_SUMMARY_STARTED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: true
        }
      };
    }

    case types.LOAD_PARTNER_CONTACT_INFO_SUMMARY_SUCCEEDED: {
      return {
        ...state,
        [action.id]: {
          loaded: true,
          loading: false
        }
      };
    }

    case types.LOAD_PARTNER_CONTACT_INFO_SUMMARY_FAILED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: false
        }
      };
    }

    case types.UPDATE_CONTACT_MODES_SUCCEEDED: {
      return {
        ...state,
        [action.partnerId]: {
          loaded: false,
          loading: false
        }
      };
    }

    case types.UPDATE_CONTACT_INFOS_SUCCEEDED: {
      return {
        ...state,
        [action.key]: {
          loaded: false,
          loading: false
        }
      };
    }

    case types.PARTNER_CONTACT_MODES_INVALIDATED: {
      return {
        ...state,
        [action.key]: {
          loaded: false,
          loading: false
        }
      };
    }

    default:
      return state;
  }
};

const activityFieldsSummaryReducer = (state = initialState.summary.activityFieldsSummary, action) => {
  switch (action.type) {
    case types.LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_STARTED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: true
        }
      };
    }

    case types.LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_SUCCEEDED: {
      return {
        ...state,
        [action.id]: {
          loaded: true,
          loading: false
        }
      };
    }

    case types.LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_FAILED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: false
        }
      };
    }

    case types.UPDATE_ACTIVITY_FIELDS_SUCCEEDED: {
      return {
        ...state,
        [action.partnerId]: {
          loaded: false,
          loading: false
        }
      };
    }

    default:
      return state;
  }
};

const bankAccountsSummaryReducer = (state = initialState.summary.bankAccountsSummary, action) => {
  switch (action.type) {
    case types.LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_STARTED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: true
        }
      };
    }

    case types.LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_SUCCEEDED: {
      return {
        ...state,
        [action.id]: {
          loaded: true,
          loading: false
        }
      };
    }

    case types.LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_FAILED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: false
        }
      };
    }

    case types.UPDATE_BANK_ACCOUNTS_SUCCEEDED: {
      return {
        ...state,
        [action.partnerId]: {
          loaded: false,
          loading: false
        }
      };
    }

    default:
      return state;
  }
};

const partnerAddressesSummaryReducer = (state = initialState.summary.partnerAddressesSummary, action) => {
  switch (action.type) {
    case types.LOAD_PARTNER_ADDRESSES_SUMMARY_STARTED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: true
        }
      };
    }

    case types.LOAD_PARTNER_ADDRESSES_SUMMARY_SUCCEEDED: {
      return {
        ...state,
        [action.id]: {
          loaded: true,
          loading: false
        }
      };
    }

    case types.LOAD_PARTNER_ADDRESSES_SUMMARY_FAILED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: false
        }
      };
    }

    case types.UPDATE_ADDRESS_SUCCEEDED: {
      return {
        ...state,
        [action.partnerId]: {
          loaded: false,
          loading: false
        }
      };
    }

    default:
      return state;
  }
};

const shareholdersSummaryReducer = (state = initialState.summary.shareholdersSummary, action) => {
  switch (action.type) {
    case types.LOAD_PARTNER_SHAREHOLDERS_SUMMARY_STARTED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: true
        }
      };
    }

    case types.LOAD_PARTNER_SHAREHOLDERS_SUMMARY_SUCCEEDED: {
      return {
        ...state,
        [action.id]: {
          loaded: true,
          loading: false
        }
      };
    }

    case types.LOAD_PARTNER_SHAREHOLDERS_SUMMARY_FAILED: {
      return {
        ...state,
        [action.id]: {
          loaded: false,
          loading: false
        }
      };
    }

    case types.UPDATE_SHAREHOLDERS_SUCCEEDED: {
      return {
        ...state,
        [action.partnerId]: {
          loaded: false,
          loading: false
        }
      };
    }

    default:
      return state;
  }
};

export default combineReducers({
  contactInfoSummary: contactInfoSummaryReducer,
  activityFieldsSummary: activityFieldsSummaryReducer,
  bankAccountsSummary: bankAccountsSummaryReducer,
  partnerAddressesSummary: partnerAddressesSummaryReducer,
  shareholdersSummary: shareholdersSummaryReducer
});
